class TruckModel {
  constructor() {
    this.patent = ''
    this.fuel_level = 0.0
    this.percent = 0.0
    this.last_charge_day = ''
    this.last_charge_hour = ''
    this.active = false
    this.dataLoss = false
    this.disconnected_sources = false
    this.full_connected = false
    this.go_supply = false
    this.loading = false
    this.all_disconnected_sources = false
    this.charge_station = []
    this.diff_hrs = 0
    this.name_disconnected_source = []
    this.truck_last_charge = 0
    this.source = ''
    this.fuel_rate = 0
    this.cycles = 0
    this.distancia_gps = 0
    this.t_encendido = 0
    this.ratio_carga = null
    this.ultima_carga_parcial = false
    this.capacidad_ciclo = 0
    this.enviar_a_carga = false
    this.horas_hasta_carga = null
    this.hora_estimada_carga = null
    this.hora_estimada_critico = null
    this.date_gps = null
    this.date_loads = null
    this.date_fuel = null
    this.alerta_combustible = false
    this.urgencia_combustible = 'normal'
  }

  fromV1 = truck => {
    this.patent = truck.truck_patent
    this.fuel_level = truck.truck_actual_litres
    this.percent = truck.truck_percent
    this.last_charge_day = truck.truck_date_last_charge_day
    this.last_charge_hour = truck.truck_date_last_charge_time
    this.charge_station = truck.charge_station
    this.name_disconnected_source = truck.name_disconnected_source
    this.truck_last_charge = parseInt(truck.truck_last_charge)
    this.diff_hrs = parseInt(truck.diff_hrs)
    this.source = truck.source
    this.active = truck.truck_status === 1
    this.fuel_rate = truck.tasa_consumo
    this.distancia_gps = (truck.distancia_gps / 1000).toFixed(0)
    this.t_encendido = truck.t_encendido.toFixed(1)
    this.ratio_carga = truck.ratio_carga ?? null
    this.capacidad_ciclo = truck.capacidad_ciclo ?? 0
    this.ultima_carga_parcial = [1, '1', true, 'True', 'true'].includes(truck.ultima_carga_parcial)
    this.enviar_a_carga = [1, '1'].includes(truck.enviar_a_carga)
    this.horas_hasta_carga =
      truck.horas_hasta_carga != null && Number.isFinite(Number(truck.horas_hasta_carga))
        ? Number(truck.horas_hasta_carga)
        : null
    this.hora_estimada_carga = truck.hora_estimada_carga || null
    this.hora_estimada_critico = truck.hora_estimada_critico || null
    this.date_gps = truck.date_gps || null
    this.date_loads = truck.date_loads || null
    this.date_fuel = truck.date || null
    // 'normal' | 'media' | 'alta' | 'critica' — 'alta'/'critica' also set alerta_combustible true
    this.urgencia_combustible = truck.urgencia_combustible || 'normal'
    this.alerta_combustible = truck.alerta_combustible === true
    // eslint-disable-next-line
    if (truck.hasOwnProperty('dataLoss')) {
      this.dataLoss = truck.dataLoss === 1
    }
    // eslint-disable-next-line
    if (truck.hasOwnProperty('disconnected_sources')) {
      this.disconnected_sources = truck.disconnected_sources === 1
    }
    // eslint-disable-next-line
    if (truck.hasOwnProperty('all_disconnected_sources')) {
      this.all_disconnected_sources = truck.all_disconnected_sources === 1
    }
    // eslint-disable-next-line
    if (truck.hasOwnProperty('full_connected')) {
      this.full_connected = truck.full_connected === 1
    }
    // eslint-disable-next-line
    if (truck.hasOwnProperty('go_supply')) {
      this.go_supply = truck.go_supply === 1
    }
    // eslint-disable-next-line
    if (truck.hasOwnProperty('loading')) {
      this.loading = truck.loading === 1
    }
    return this
  }
}

export default TruckModel
